import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';

export const buildCardStyle = (tileColor: string) => css`
	display: flex;
	align-items: center;
	gap: 1rem;
	padding: 1.25rem 1.375rem;
	border-radius: ${theme.radii.xlarge};
	border: 1.5px solid ${theme.colors.border};
	background-color: ${theme.colors.surface};
	color: ${theme.colors.ink};
	text-decoration: none;

	&:hover {
		border-color: ${tileColor};
	}

	&:focus-visible {
		outline: 3px solid ${theme.colors.accent};
		outline-offset: 2px;
	}
`;

export const cardTextStyle = css`
	display: flex;
	flex-direction: column;
	flex: 1;
	gap: 0.25rem;
	min-width: 0;
`;

export const cardTitleStyle = css`
	${theme.typography.cardTitle}
	font-size: 1.0625rem;
	line-height: 1.2;
`;

export const chevronStyle = css`
	display: flex;
	flex: none;
	color: ${theme.colors.accent};
`;

export const sectionStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
`;

export const gridStyle = css`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 0.875rem;

	@media (max-width: ${theme.layout.compactBreakpoint}) {
		grid-template-columns: minmax(0, 1fr);
	}
`;

export const eyebrowTitleStyle = css`
	${theme.typography.eyebrow}
	margin: 0;
	font-size: 0.6875rem;
	text-transform: uppercase;
	color: ${theme.colors.inkMuted};
`;

export const cardFigureStyle = css`
	font-family: ${theme.fonts.body};
	font-size: 0.84375rem;
	font-weight: ${theme.fontWeights.medium};
	line-height: 1.3;
	color: ${theme.colors.ink};
`;

export const cardFacilityStyle = css`
	font-family: ${theme.fonts.mono};
	font-size: 0.71875rem;
	line-height: 1.3;
	color: ${theme.colors.inkMuted};
`;

export const captionStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: 0.78125rem;
	line-height: 1.5;
	color: ${theme.colors.inkMuted};
`;

export const captionRowStyle = css`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.5rem;
`;
